import { StyledCircle, StyledRect, StyledSvg } from './StatusIcon.styled';

interface IStatusIconProps extends React.HTMLAttributes<SVGElement> {
	active: boolean;
}

const StatusIcon: React.FC<IStatusIconProps> = ({
	active,
	...props
}: IStatusIconProps) => {
	return (
		<StyledSvg
			width="30"
			height="20"
			viewBox="0 0 30 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<StyledRect $active={active} width="30" height="20" rx="10" />
			<StyledCircle $active={active} cx="20" cy="10" r="5" />
			<rect
				x="0.5"
				y="0.5"
				width="29"
				height="19"
				rx="9.5"
				stroke="white"
				strokeOpacity="0.1"
			/>
		</StyledSvg>
	);
};

export { StatusIcon };
